//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';

import { IActionCreatorMap } from '@utils/types/ActionCreators';

/**
 * Prefer use of useDispatch from 'react-redux'
 * Bound action creators is an anti-pattern
 *
 * @deprecated
 */
export function useBoundActionCreators<T extends IActionCreatorMap>(
  actionCreators: T,
) {
  const reduxDispatch = useDispatch();
  return bindActionCreators<T>(actionCreators, reduxDispatch);
}
